import React from 'react';
import MainLayout from '../containers/layouts/MainLayout/MainLayout';
import ErrorLayout from '../containers/layouts/ErrorLayout/ErrorLayout';
import EmptyLayout from '../containers/layouts/EmptyLayout/EmptyLayout';

const routes = [
  {
    id: 'events',
    path: '/events/:acc',
    exact: false,
    layout: MainLayout,
    component: React.lazy(() => import('./Events')),
  },
  {
    id: 'actorsGraph',
    path: '/actors_graph/:acc',
    exact: false,
    layout: MainLayout,
    component: React.lazy(() => import('./ActorsGraph')),
  },
  {
    id: 'files',
    path: '/files/:acc/:action?/:id?',
    exact: true,
    layout: MainLayout,
    component: React.lazy(() => import('./Files')),
  },
  {
    id: 'settings',
    path: '/settings/:acc/:action',
    exact: true,
    layout: MainLayout,
    component: React.lazy(() => import('./Settings')),
  },
  {
    id: 'not_found',
    path: '/not_found',
    exact: true,
    layout: ErrorLayout,
    component: React.lazy(() => import('./NotFound')),
  },
  {
    id: 'access_denied',
    path: '/access_denied',
    exact: true,
    layout: ErrorLayout,
    component: React.lazy(() => import('./AccessDenied')),
  },
  {
    id: 'under_construction',
    path: '/under_construction',
    exact: true,
    layout: MainLayout,
    component: React.lazy(() => import('./UnderConstruction')),
  },
  {
    id: 'error',
    path: '/error/:id?',
    exact: true,
    layout: ErrorLayout,
    component: React.lazy(() => import('./Error')),
  },
  {
    id: 'resources',
    path: '/resources',
    exact: true,
    layout: MainLayout,
    component: React.lazy(() => import('./Resources')),
  },
  {
    id: 'scriptsList',
    path: '/scripts_list/:acc',
    exact: false,
    layout: MainLayout,
    component: React.lazy(() => import('./Scripts')),
  },
  {
    id: 'scriptsItem',
    path: '/scripts_item/:acc',
    exact: false,
    layout: MainLayout,
    component: React.lazy(() => import('@control-front-end/scripts')),
  },
  {
    id: 'script',
    path: '/script/:acc',
    exact: false,
    layout: EmptyLayout,
    component: React.lazy(() => import('@control-front-end/scripts')),
  },
];

export default routes;
